<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.66665 13.3334V6.66669M6.66665 13.3334V2.66669M10.6666 13.3334V8.66669M14.6666 13.3334H1.33331" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

